var ETypes = /* @__PURE__ */ ((ETypes2) => {
  ETypes2["Vip"] = "Vip";
  ETypes2["Trade"] = "Trade";
  return ETypes2;
})(ETypes || {});
var ETradeTypes = /* @__PURE__ */ ((ETradeTypes2) => {
  ETradeTypes2["Vip"] = "SOLUTION";
  ETradeTypes2["AdditionVip"] = "ADDITION_PACKAGE";
  ETradeTypes2["Seat"] = "ADDITION";
  ETradeTypes2["Certs"] = "CERTS";
  ETradeTypes2["Matting"] = "MATTING";
  ETradeTypes2["AIPoint"] = "AI_POINT";
  ETradeTypes2["Store"] = "STORAGE_SPACE";
  return ETradeTypes2;
})(ETradeTypes || {});
var ESeatTypes = /* @__PURE__ */ ((ESeatTypes2) => {
  ESeatTypes2["Gdesign"] = "gdesign";
  ESeatTypes2["Creation"] = "gdcreate";
  ESeatTypes2["Insmind"] = "gdproductimg";
  return ESeatTypes2;
})(ESeatTypes || {});
var BuyApplicationModalType = /* @__PURE__ */ ((BuyApplicationModalType2) => {
  BuyApplicationModalType2["AIPoint"] = "AI_POINT";
  BuyApplicationModalType2["Matting"] = "MATTING";
  BuyApplicationModalType2["Certs"] = "CERTS";
  BuyApplicationModalType2["Seat"] = "ADDITION";
  BuyApplicationModalType2["Store"] = "STORAGE_SPACE";
  BuyApplicationModalType2["Vip"] = "SOLUTION";
  BuyApplicationModalType2["VipAddition"] = "ADDITION_PACKAGE";
  return BuyApplicationModalType2;
})(BuyApplicationModalType || {});
const ETypesIsTrade = [
  "AI_POINT",
  "MATTING",
  "CERTS",
  "ADDITION",
  "STORAGE_SPACE",
  "ADDITION_PACKAGE"
  /* VipAddition */
];
const IFRAME_ID_PREFIX = "buy-buy-application-modal-next";
const LOADING_TIMEOUT = 3 * 1e3;
const LOADING_RETRY = 2;
const ENV = "dev";
const EventName = {
  open: "onOpen",
  close: "onClose",
  complete: "onComplete",
  error: "onError"
};
var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Route {
  constructor(options) {
    __publicField$2(this, "path", "");
    __publicField$2(this, "params", {});
    const baseUrl = options.baseUrl ? options.baseUrl : window.origin || "https://www.gaoding.com";
    this.params = this.getParams(options);
    const trackerData = this.getTrackerData(options);
    this.path = "".concat(baseUrl, "/pricing/redirect?trackerData=").concat(JSON.stringify(
      trackerData
    ), "&params=").concat(JSON.stringify(this.params));
  }
  /**
   * @description
   * 外部可以直接传入options.params = { type: ETypes.xx, tradeType: ETradeTypes.xx }
   * 也可以通过传入options.type = BuyApplicationModalType.xxx ，根据options.type自动填充options.params的type和tradeType
   */
  getParams(options) {
    let params = {};
    if (options.type) {
      if (ETypesIsTrade.includes(options.type)) {
        params.type = ETypes.Trade;
      } else {
        params.type = ETypes.Vip;
      }
      params.tradeType = options.type;
      params = {
        ...options.params || {},
        ...params
      };
    } else {
      params = options.params || {};
    }
    return params;
  }
  getTrackerData(options) {
    return options.trackerData || {};
  }
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Views {
  constructor(options) {
    __publicField$1(this, "iframe", null);
    __publicField$1(this, "content", null);
    __publicField$1(this, "uuid");
    __publicField$1(this, "lifecycle");
    __publicField$1(this, "path");
    __publicField$1(this, "zIndex", 9999);
    __publicField$1(this, "mask", true);
    __publicField$1(this, "loaded", false);
    __publicField$1(this, "componentModalClose");
    __publicField$1(this, "_evenetListener");
    __publicField$1(this, "_listenerExit", (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        this.destroy();
      }
    });
    __publicField$1(this, "retryCount");
    __publicField$1(this, "timeout");
    __publicField$1(this, "timeoutControl");
    __publicField$1(this, "_buildMask", () => {
      const mask = document.createElement("div");
      mask.setAttribute("class", "gda-modal-mask");
      mask.setAttribute(
        "style",
        "position: fixed;left: 0;top:0; height:100%; width:100%;z-index:".concat(this.zIndex - 2, ";display:flex;justify-content: center;align-items:center;background-color: rgba(0,0,0,.6);")
      );
      window.addEventListener("keydown", this._listenerExit, true);
      return mask;
    });
    var _a;
    this.uuid = "".concat(IFRAME_ID_PREFIX, "_").concat((/* @__PURE__ */ new Date()).getTime());
    this.lifecycle = options.lifecycle;
    this.path = options.path;
    this.retryCount = options.retryCount !== void 0 ? options.retryCount : LOADING_RETRY;
    this.timeout = options.timeout !== void 0 ? options.timeout : LOADING_TIMEOUT;
    this.zIndex = (_a = options.zIndex) != null ? _a : this.zIndex;
    this.mask = options.mask !== void 0 ? options.mask : this.mask;
    return this;
  }
  _buildContent() {
    const content = document.createElement("div");
    content.id = "".concat(this.uuid, "_content");
    const displayedStyle = "height:100vh;width:100vw;border:none;position:fixed;top:0;left:0;z-index:".concat(this.zIndex);
    content.setAttribute("style", displayedStyle);
    this.content = content;
    return content;
  }
  _buildLoading() {
    const span = document.createElement("span");
    span.setAttribute("class", "gda-spin-dot gda-spin-dot-spin");
    for (let i = 0; i < 4; i += 1) {
      const dot = document.createElement("i");
      dot.setAttribute("class", "gda-spin-dot-item");
      dot.setAttribute("style", "background-color:#fff");
      span.append(dot);
    }
    const loading = document.createElement("div");
    loading.setAttribute("class", "gda-spin gda-spin-spinning");
    loading.append(span);
    return loading;
  }
  _buildIframe() {
    this.destroy();
    const iframe = document.createElement("iframe");
    const iframeStyle = "height:100%;width:100%;border:none;background-color:transparent;position:relative;z-index:".concat(this.zIndex - 1);
    iframe.setAttribute("allowtransparency", "true");
    iframe.src = this.path.path;
    iframe.id = this.uuid;
    iframe.setAttribute("style", "".concat(iframeStyle, ";visibility:hidden"));
    const content = this._buildContent();
    if (this.mask) {
      const mask = this._buildMask();
      const loading = this._buildLoading();
      mask.append(loading);
      content.append(mask);
    }
    content.append(iframe);
    document.body.append(content);
    this._buildIframeListener(iframe, iframeStyle);
    return iframe;
  }
  _buildIframeListener(iframe, iframeStyle) {
    iframe.addEventListener("error", () => {
      this.destroy();
    });
    this._evenetListener = async (event) => {
      var _a;
      const data = event.data;
      if (!data)
        return;
      const method = data.method;
      const type = data.type;
      const dataSource = data.data;
      if (type !== "buy-application-modal-type") {
        return;
      }
      if (method === EventName.open) {
        iframe.setAttribute("style", iframeStyle);
        if (!this.mask) {
          (_a = this.content) == null ? void 0 : _a.append(this._buildMask());
        }
        this.loaded = true;
        clearTimeout(this.timeout);
        await this._callLifecycle(EventName.open, dataSource);
      } else if (method === EventName.close) {
        await this._callLifecycle(EventName.close, dataSource);
        this.destroy();
      } else {
        await this._callLifecycle(method, dataSource);
      }
    };
    window.addEventListener("message", this._evenetListener);
    return iframe;
  }
  /** 超时重试机制 */
  _retryWhileTimeout() {
    if (this.timeoutControl)
      clearTimeout(this.timeoutControl);
    this.timeoutControl = setTimeout(() => {
      var _a, _b, _c;
      if (!this.loaded) {
        if (this.retryCount > 0) {
          console.log("第".concat(LOADING_RETRY - this.retryCount + 1, "次请求重试"), this.loaded);
          this.retryCount -= 1;
          if (this.iframe) {
            this.iframe.src = this.path.path;
          }
          this._retryWhileTimeout();
        } else {
          ((_a = this.lifecycle) == null ? void 0 : _a.onError) && typeof ((_b = this.lifecycle) == null ? void 0 : _b.onError) === "function" && ((_c = this.lifecycle) == null ? void 0 : _c.onError());
          this.destroy();
          if ((window == null ? void 0 : window.GD_SLS_RUM) && (window == null ? void 0 : window.GD_SLS_RUM.addError)) {
            window == null ? void 0 : window.GD_SLS_RUM.addError(new Error("商业化弹窗错误"));
          }
        }
      }
    }, this.timeout);
  }
  async _callLifecycle(method, data) {
    if (this.lifecycle && this.lifecycle[method] && typeof this.lifecycle[method] === "function") {
      this.lifecycle[method](data);
    }
  }
  open() {
    this.iframe = this._buildIframe();
    this._retryWhileTimeout();
  }
  destroy() {
    const elements = document.querySelectorAll('[id^="'.concat(IFRAME_ID_PREFIX, '"]'));
    elements.forEach((element) => {
      element.remove();
    });
    this.iframe = null;
    this.loaded = false;
    if (this.timeoutControl) {
      window.clearTimeout(this.timeoutControl);
    }
    if (this.componentModalClose && typeof this.componentModalClose === "function") {
      this.componentModalClose();
    }
    if (this._evenetListener) {
      window.removeEventListener("message", this._evenetListener);
      this._evenetListener = void 0;
    }
    window.removeEventListener("keydown", this._listenerExit, true);
  }
}
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Controller {
  /** 初始化默认参数 */
  constructor() {
    __publicField(this, "_instance", null);
    __publicField(this, "views", null);
    __publicField(this, "path");
    if (this._instance) {
      return this._instance;
    }
    this._instance = this;
    return this;
  }
  get loaded() {
    var _a, _b;
    return (_b = (_a = this.views) == null ? void 0 : _a.loaded) != null ? _b : false;
  }
  // 关闭
  async close() {
    var _a;
    await ((_a = this.views) == null ? void 0 : _a.destroy());
    this.views = null;
    return this;
  }
  open(data) {
    const path = new Route(data);
    const views = new Views({
      lifecycle: data.lifecycle,
      path,
      retryCount: data.retryCount,
      timeout: data.timeout,
      mask: data.mask
    });
    this.views = views;
    this.views.open();
    return this;
  }
}
const useCheckVipStatus = () => {
  console.warn(
    "[useCheckVipStatus]该方法在 iframe-modal 包内已经废弃, 请从 @gdesign/commerce-core/hooks 引入"
  );
  return {
    state: {},
    params: {},
    /**
     * check 当前类型的方法
     */
    handleCheck: () => {
    }
  };
};
const useBusinessModal = (dataParams) => {
  const controller = new Controller();
  const open = (onOpen = (_) => {
  }) => {
    controller.open({
      ...dataParams || {},
      trackerData: dataParams.trackerData,
      lifecycle: {
        ...dataParams == null ? void 0 : dataParams.lifecycle,
        onOpen() {
          var _a, _b;
          onOpen(true);
          ((_a = dataParams == null ? void 0 : dataParams.lifecycle) == null ? void 0 : _a.onOpen) && ((_b = dataParams == null ? void 0 : dataParams.lifecycle) == null ? void 0 : _b.onOpen());
        },
        onError() {
          onOpen(false);
        }
      }
    });
  };
  const close = () => {
    controller.close();
  };
  return {
    controller,
    open,
    close
  };
};
const version = "0.1.14";
export {
  BuyApplicationModalType,
  Controller,
  ENV,
  ESeatTypes,
  ETradeTypes,
  ETypes,
  ETypesIsTrade,
  EventName,
  IFRAME_ID_PREFIX,
  LOADING_RETRY,
  LOADING_TIMEOUT,
  useBusinessModal,
  useCheckVipStatus,
  version
};
